<template>

    <div class="slider">
        <div class="slider-header">
            <v-switch class="mr-10" checked @input="updateInterval" />
            <span>Save 20% with annual billing</span>
        </div>
        <div class="slider-body">
            <div class="slider-title">
                <div class="price">{{ amountForQuantity / 100 | numeral('$0,0') }}<span class="small"> / month</span></div>
                <div>{{ quantity | numeral('0,0') }} Customers / Unlimited Emails</div>
            </div>
            <v-slider class="mb-60"
                v-model="quantity"
                :adsorb="true"
                :duration=".3"
                :height="10"
                :marks="marks"
                :tooltip="'none'"
                :data="[500,1000,5000,10000,25000,50000,100000]">
            </v-slider>
            <v-button size="lg" class="m-auto" @click.native="signup">Start Free Trial</v-button>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .slider {

        background: #fff;
        border: 2px solid $color-primary;
        border-radius: 5px;
        margin-top: -143px;
        overflow: hidden;

        .slider-header {
            @include font-semibold(12px);
            align-items: center;
            border-bottom: 1px solid $color-rule;
            display: flex;
            line-height: normal;
            padding: 20px;
        }

        .slider-body {
            padding: 60px;
        }

        .slider-title {
            @include font-medium(18px);
            line-height: 1.6em;
            margin-bottom: 20px;
            text-align: center;
            .price {
                @include font-medium(30px);
                color: $color-text;
                height: 1em;
                margin-bottom: 10px;
                .small {
                    @include font-semibold(14px);
                }
            }
        }

    }

</style>

<script>

import numeral from 'numeral';
import VueSlider from 'vue-slider-component';

export default {

    components: {
        'v-slider': VueSlider,
    },

    data() {
        return {
            interval: 'year',
            quantity: 500,
            tiers: {
                500: 60,
                1000: 70,
                5000: 150,
                10000: 250,
                25000: 425,
                50000: 550,
                100000: 1050,
            },
            marks: val => ({ label: numeral(val).format('0a') }),
        }
    },

    computed: {

        amountForQuantity() {
            let amount = 0;
            for (let [key, value] of Object.entries(this.tiers)) {
                if (parseInt(key) === parseInt(this.quantity)) {
                    amount = value * 100;
                    break;
                }
            };
            return this.interval === 'month' ? amount : (amount - (amount * 0.2));
        },

    },

    methods: {

        updateInterval(e) {
            this.interval = e.target.checked ? 'year' : 'month';
        },

        signup() {
            window.location.href = process.env.VUE_APP_APP_URL + '/signup';
        },

    },

}

</script>